import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as enCommon from "@utils/stringLocalization/common.json";

export const defaultNS = "common";

// eslint-disable-next-line unicorn/no-top-level-side-effects -- i18next must be initialized on import
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  debug: true,
  ns: [defaultNS],
  defaultNS,
  resources: {
    en: {
      common: enCommon,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export { default } from "i18next";
